import { Route, Routes } from "react-router-dom";

import HoaDon from "./hoa-don";
import ThongBaoSaiSot from "./thong-bao-sai-sot";
import ToKhaiDangKy from "./to-khai-dang-ky";
import { PrivateRoute } from "../components/PrivateRoute";
import { ROLE } from "../../Constant";
import ThanhToanQr from "./thanh-toan-qrcode";

export default function LichSuTruyenNhan() {
  return (
    <Routes>
      <Route
        path='/hoa-don/*'
        element={
          <PrivateRoute role={ROLE.MGATEWAY_INVOICE}>
            {" "}
            <HoaDon />
          </PrivateRoute>
        }
      />
      <Route
        path='/thong-bao-sai-sot/*'
        element={
          <PrivateRoute role={ROLE.MGATEWAY_WRONG_INVOICE}>
            {" "}
            <ThongBaoSaiSot />
          </PrivateRoute>
        }
      />
      <Route
        path='/to-khai-dang-ky/*'
        element={
          <PrivateRoute role={ROLE.MGATEWAY_DECLARE}>
            {" "}
            <ToKhaiDangKy />
          </PrivateRoute>
        }
      />
      <Route path='/thanh-toan-qr*' element={<ThanhToanQr />} />
    </Routes>
  );
}
